import { Button, Grid } from '@material-ui/core'
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date'
import { useContext, useEffect, useState } from 'react'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { updateProject } from '../../../actions/projectActions'
import {
  PROJECT_CURRENT_STEP,
  PROJECT_EXIT_REQUEST,
  PROJECT_UPDATE_RESET,
} from '../../../constants/projectConstants'
import { useInput } from '../../../hooks/useInput'
import { Context } from '../../../providers/ProjectContextProvider'
import Datepicker from '../../Form/Datepicker'
import FormContainer from '../../Form/FormContainer'
import TextAreaInput from '../../Form/TextAreaInput'
import './selectTimeframe.scss'

const SelectTimeframe = () => {
  const dispatch = useDispatch()

  const { setShowNotifyUser } = useContext(Context)

  const [saveAndExit, setSaveAndExit] = useState(false)
  const [selectedDate, setSelectedDate] =
    useState<MaterialUiPickersDate | null>(null)
  const [stayOnPage, setStayOnPage] = useState(false)

  const { value: deliveryDateComments, bind: bindDeliveryDateComments } =
    useInput('')

  const { project } = useSelector(
    (state: RootStateOrAny) => state.projectDetails
  )
  const { loading: loadingUpdate, success: successUpdate } = useSelector(
    (state: RootStateOrAny) => state.projectUpdate
  )
  const { userInfo } = useSelector(
    (state: { userLogin: UserLogin }) => state.userLogin
  )

  useEffect(() => {
    if (successUpdate) {
      dispatch({ type: PROJECT_UPDATE_RESET })

      if (stayOnPage) {
        setStayOnPage(false)
      } else {
        if (saveAndExit) {
          dispatch({ type: PROJECT_EXIT_REQUEST })
        } else {
          dispatch({
            type: PROJECT_CURRENT_STEP,
            payload: 7,
          })
        }
      }
    }

    if (project.deliveryDate) {
      setSelectedDate(project.deliveryDate)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successUpdate, dispatch, setSelectedDate, project, saveAndExit])

  const addDeliveryDateToProject = () => {
    let projectClone = JSON.parse(JSON.stringify(project)) // deep cloning

    projectClone.deliveryDate = selectedDate
    projectClone.deliveryDateComments = deliveryDateComments

    dispatch(updateProject(projectClone))
  }

  const handleSaveAndExit = () => {
    if (userInfo.isAdmin) {
      setStayOnPage(true)
      setShowNotifyUser(true)
      addDeliveryDateToProject()
    } else {
      setSaveAndExit(true)
      addDeliveryDateToProject()
    }
  }

  return (
    <div className="select-timeframe">
      <FormContainer>
        <div className="flex space-between">
          <h4 className="m-b-30">
            Select timeframe{' '}
            {userInfo.isAdmin && project.userName && `for ${project.userName}`}
          </h4>
        </div>
        <p>
          Select your desired delivery date. Timeframes selected here are not
          guarantees -{' '}
          <strong>
            if the desired timeframe for your program is less than two weeks
            away, we may be unable to accommodate your request.
          </strong>
        </p>

        <Grid container>
          <Grid item xs={6}>
            <Datepicker value={selectedDate} setValue={setSelectedDate} />
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={12}>
            <TextAreaInput
              name="dateComments"
              label="Comments (optional)"
              bindValue={bindDeliveryDateComments}
              rows={4}
            />
          </Grid>
        </Grid>

        <div className="actions m-t-40">
          <Button
            variant="contained"
            color="primary"
            disabled={loadingUpdate}
            className={loadingUpdate ? 'loading' : ''}
            onClick={handleSaveAndExit}
          >
            Save and exit
          </Button>

          <div>
            <Button
              variant="outlined"
              color="primary"
              onClick={() =>
                dispatch({
                  type: PROJECT_CURRENT_STEP,
                  payload: 5,
                })
              }
              disabled={loadingUpdate}
              className={loadingUpdate ? 'loading' : ''}
            >
              Back
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ marginLeft: 20 }}
              disabled={!selectedDate || loadingUpdate}
              onClick={addDeliveryDateToProject}
              className={loadingUpdate ? 'loading' : ''}
            >
              Next
            </Button>
          </div>
        </div>
      </FormContainer>
    </div>
  )
}

export default SelectTimeframe
